// src/components/MobileHeader.jsx
import React from "react";

const MobileHeader = () => (
  <div className="header-device-mobile">
    <div className="wapper">
      <div className="item mobile-logo">
        <div className="logo">
          <a href="#">
            <img src="assets/images/logo.png" alt="img" />
          </a>
        </div>
      </div>
      <div className="item item mobile-search-box has-sub">
        <a href="#">
          <span className="icon">
            <i className="fa fa-search" aria-hidden="true"></i>
          </span>
        </a>
        <div className="block-sub">
          <a href="#" className="close">
            <i className="fa fa-times" aria-hidden="true"></i>
          </a>
          <div className="header-searchform-box">
            <form className="header-searchform">
              <div className="searchform-wrap">
                <input type="text" className="search-input" placeholder="Enter keywords to search..." />
                <input type="submit" className="submit button" value="Search" />
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="item mobile-settings-box has-sub">
        <a href="#">
          <span className="icon">
            <i className="fa fa-cog" aria-hidden="true"></i>
          </span>
        </a>
        <div className="block-sub">
          <a href="#" className="close">
            <i className="fa fa-times" aria-hidden="true"></i>
          </a>
          <div className="block-sub-item">
            <h5 className="block-item-title">Currency</h5>
            <form className="currency-form ysera-language">
              <ul className="ysera-language-wrap">
                <li className="active"><a href="#"><span>English (USD)</span></a></li>
                <li><a href="#"><span>French (EUR)</span></a></li>
                <li><a href="#"><span>Japanese (JPY)</span></a></li>
              </ul>
            </form>
          </div>
        </div>
      </div>
      <div className="item menu-bar">
        <a className="mobile-navigation menu-toggle" href="#">
          <span></span>
          <span></span>
          <span></span>
        </a>
      </div>
    </div>
  </div>
);

export default MobileHeader;